import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  if (!isApiRequest(req.url)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status >= 500) {
        messageService.add({
          severity: 'error',
          summary: 'Server Error',
          detail: 'An unexpected server error occurred. Please try again or contact support.',
          life: 8000
        });
      }
      throw err;
    })
  );
};

function isApiRequest(url: string): boolean {
  try {
    return new URL(url).origin === new URL(environment.baseApiUrl).origin;
  } catch {
    return false;
  }
}
